<template>
	<v-list>
		<v-list-item>
			<v-list-item-content>			
				<v-list-item-title>{{video_room.projectName}}</v-list-item-title>
				<v-list-item-subtitle>{{ video_room.dateTime.toDate() | moment("DD/MM/YYYY, HH:mm") }}</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<style lang="less">
	.notes-wrapper{
		font-size: 0.8em;
		overflow-y: scroll;
	}

	.note-content {
		font-size: 0.8em !important; 
	}
	.roomTime {
		color: darkgrey;
		font-size: 0.7em;
	}
	.timeSince {
		color: navy;
		font-size: 0.7em;
	}
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	export default {
		name: "ProjectInfo", 
		props: {
		},
		data: () => {
			return {
			}
		},
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user,
				video_room: state => state.video,
				room_instance: state => state.video.roomInstance, 
				participant: state => state.video.participant,
				participantNotes: state => state.video.participantNotes
			}),
		},
		methods: {


		},
		created(){

		}

	}
// </script>"